import React from 'react'
import { CardFrame } from '../../../ui/CardFrame/CardFrame.jsx'
import { FeedbackEntryList } from '../interactions/FeedbackEntryList.jsx'

/**
 * FeedbackGivenCard — session-feedback (catalog #9, non-core).
 *
 * Live ledger with direction-tagged manager↔report entries.
 * Reuses FeedbackEntryList interaction with manager-to-report /
 * report-to-manager MiniPill kinds.
 */

export function FeedbackGivenCard({ text = '', onChange, disabled = false, isManagerView = false }) {
  let items = []
  try {
    if (text) items = JSON.parse(text)
  } catch {
    items = []
  }

  function handleChange({ items: next }) {
    onChange?.(JSON.stringify(next))
  }

  return (
    <CardFrame
      kind="session"
      icon="↔"
      iconClass="clay"
      title="Feedback given"
      prompt="What feedback was exchanged?"
      state={disabled ? 'locked' : items.length > 0 ? 'filled' : 'empty'}
      data-testid="session-card-feedback-given"
      className="session-card"
    >
      <FeedbackEntryList
        items={items}
        onChange={handleChange}
        maxItems={10}
        readOnly={disabled}
        isManagerView={isManagerView}
      />
    </CardFrame>
  )
}
